import config from "../../app.json";
import axios from "axios";

import "./input-card.scss";
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import InputIcon from "../../Assets/Images/device-icon.svg";
import AlertComponent from "../AlertComponent";
import ChurchModal from "../ChurchModal";
function InputCard(props) {
  const { id, name, attached, index, deleteApiPath, onDelete } = props;
  const [deleteItem, setDeleteItem] = useState({ invisible: false });
  const urlImage = useRef(null);

  let navigate = useNavigate();

  const setInvis = (invis) => {
    setDeleteItem({ invisible: invis });
  };
  const handleManage = (inputId) => {
    return navigate(`/manageInput/${inputId}`, { replace: false });
  };
  const handleRemove = (id, name) => {
    setDeleteItem({
      invisible: true,
      setInvisible: (invis) => setInvis(invis),
      title: name,
      content: `You're about to delete a input. Confirm deletion?`,
      createItem: `Confirm`,
      discardItem: `Cancel & Close`,
      onSubmit: () => removeChannel(id),
      messageTitle: `Success`,
      message: `The Input has been successfully deleted`,
    });
  };

  const removeChannel = (id) => {
    axios
      .post(config.API + deleteApiPath, {
        id: id,
      })
      .then((res) => {
        if (res.status === 200) {
          if (onDelete) {
            onDelete();
          }
          return;
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.error ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  const marginClass = index > 3 ? ` input-card-content-margin-top` : ``;
  return (
    <div className="list-card-content mb-4">
      <div className="event-thumb-container">
        <ChurchModal {...deleteItem} />
        {urlImage?.current == null && (
          <div
            style={{
              width: 54,
              height: 46,
              backgroundImage: "url(" + InputIcon + ")",
              backgroundSize: "cover",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 15,
                right: 15,
              }}
            ></div>
          </div>
        )}
        {urlImage?.current && (
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundImage: "url(" + urlImage.current + ")",
              backgroundSize: "cover",
              borderRadius: 20,
              overflow: "hidden",
            }}
          ></div>
        )}
      </div>
      <div className="input-card-body">
        <div className="events-meta">
          <div className="input-card-name">{name}</div>
          <div className="device-status">
              <FontAwesomeIcon
                className="input-card-element"
                style={{ color: "#9E9E9E" }}
                icon={faLink}
              />
               <div className="input-card-element">{`${
                attached ? `Attached` : `Detached`
              }`}</div>
          </div>
        </div>
        <div>
          <Row>
            <Col className="col-md-6 ">
              <Button
                className={`button-manage 2`}
                onClick={() => handleManage(id)}
              >
                Manage
              </Button>
            </Col>
            <Col className="col-md-6 d-flex justify-content-end">
              <Button
                className={`button-remove`}
                onClick={() => handleRemove(id, name)}
                disabled={attached}
              >
                Remove
              </Button>
            </Col>
          </Row>
        </div>
        
      </div>
    </div>
  );
}

export default InputCard;
